import { throttle } from "lodash"
import { Controller } from "stimulus"

import { isElementInViewport } from "../../../js/utils"

export default class extends Controller {
  static get targets() {
    return ["more"]
  }

  connect() {
    this.onScroll = throttle(this.onScroll, 200)

    this.onScroll()
  }

  onScroll() {
    this.element.querySelectorAll("a.media").forEach((anchor) => {
      anchor.classList.toggle("is-visible", isElementInViewport(anchor, false))
    })
  }
}
